import React from 'react';
import cx from 'classnames';

import TextBlock from '../TextBlock';
import TextActionAccordion, {
  TextActionAccordionProps,
} from '../TextActionAccordion';

import styles from './index.module.scss';

export interface TextWithTextActionAccordionListCardProps {
  title?: string;
  text?: string;
  accordions: TextActionAccordionProps[];
  className?: string;
}

const TextWithTextActionAccordionListCard: React.FC<
  TextWithTextActionAccordionListCardProps
> = ({ title, text, accordions, className }) => {
  return (
    <div className={cx(styles.wrapper, className)}>
      <TextBlock className={styles.textBlock} title={title} text={text} />

      <ul className={styles.accordionsWrapper}>
        {accordions.map((item, index) => {
          const formattedNumber = String(index + 1).padStart(2, '0');

          return (
            <TextActionAccordion
              key={item.title}
              number={formattedNumber}
              title={item.title}
              subtitle={item.subtitle}
              text={item.text}
              className={styles.accordionItem}
              isOpenByDefault={index === 0}
            />
          );
        })}
      </ul>
    </div>
  );
};

export default TextWithTextActionAccordionListCard;
